module.exports = __webpack_public_path__ + "static/media/Marshall Islands - MH.bbb23b16.png";